<div class="container-fluid">
  <nav
    class="navbar navbar-expand-lg navbar-light fixed-top px-3 py-1 border-dark-green d-flex justify-content-between"
  >
    <a class="navbar-brand cursor-pointer" routerLink="/">
      <img [lazyLoad]="image() | cdnUrl: 300 : true" class="align-top" alt="" />
    </a>

    <div class="d-flex align-items-center">
      <button
        (click)="toggle()"
        class="navbar-toggler ms-3"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse d-none d-lg-flex flex-row-reverse" id="navbarNav">
        <app-main-navigation [navigation]="navigation()" />
      </div>
    </div>
  </nav>
  <div
    class="d-flex d-lg-none flex-row-reverse p-3 position-absolute start-0 w-100 bg-white"
    [class.show]="toggleNavbar()"
    id="navbarNav"
  >
    <app-main-navigation
      [navigation]="navigation()"
      (closeNavigation)="$event ? toggle() : toggleNavbar()"
    />
  </div>
</div>
